export const notificationSections = {
  connected: {
    labwater: [
      { name: 'general', aliasName: 'SYSTEM_INFO' },
      { name: 'inventory', aliasName: 'INVENTORY_INFO' }
    ]
  },
  unconnected: {}
}
